import { useState, useCallback } from 'react';

interface UseVirtualScrollProps {
  totalItems: number;
  itemHeight: number;
  containerHeight: number;
  bufferSize?: number;
}

export function useVirtualScroll({
  totalItems,
  itemHeight,
  containerHeight,
  bufferSize = 10 // determines how many additional items are rendered above and below the visible area of the scrollable container
}: UseVirtualScrollProps) {
  const [scrollTop, setScrollTop] = useState(0);

  const visibleItems = Math.ceil(containerHeight / itemHeight);
  const totalHeight = totalItems * itemHeight;

  const startIndex = Math.max(
    0,
    Math.floor(scrollTop / itemHeight) - bufferSize
  );
  const endIndex = Math.min(
    totalItems - 1,
    startIndex + visibleItems + 2 * bufferSize
  );

  const items = [];
  for (let i = startIndex; i < endIndex; i++) {
    items.push({
      index: i,
      offsetTop: i * itemHeight
    });
  }

  const onScroll = useCallback((event: React.UIEvent<HTMLDivElement>) => {
    setScrollTop(event.currentTarget.scrollTop);
  }, []);

  return {
    items,
    totalHeight,
    onScroll
  };
}
